module.exports = __webpack_public_path__ + "media/images/creator/story_count_achievement_mailer/ogp_image_1000-2f199163e5d0ed5be43c3020236afcda.png";